const defaultApiBaseUrl = process.env.NODE_ENV === 'development'
  ? 'http://localhost:4001'
  : 'https://api.mtqcp.com.tw';

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || defaultApiBaseUrl;
